// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2Sbgb","row":"ProcedureTreatmentSummary_row__qQWf0"};